import angular from 'angular';
import uiRouter from 'angular-ui-router';
import advertEditPageComponent from './advertEditPage.component';

let advertEditPageModule = angular.module('advertEditPage', [
  uiRouter
])

.component('advertEditPage', advertEditPageComponent)

.name;

export default advertEditPageModule;
